import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/lib/motion";
import { FAQS } from "@/data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="max-w-5xl mx-auto px-6 md:px-12 py-8 md:py-12">
      <div className="grid md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <Eyebrow>Questions</Eyebrow>
          <h2 className="mt-5 font-display font-normal text-4xl md:text-5xl tracking-tight">
            Good to know.
          </h2>
        </div>
        <div className="md:col-span-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-peach" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-xl md:text-2xl hover:no-underline py-6 text-brand-ink">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-ink/75 text-base leading-relaxed pb-6 whitespace-pre-line">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
